import { Component, OnInit, Inject,ElementRef,OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CommonService, AlertService, AdminService, LeadService, ProjectService } from '../../../_services/';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { emailList } from '../../../_helper/global';
import { Subscription } from 'rxjs';
import { emailListCreateContact } from '../../../_helper/global';

// Algolia
import algoliasearch from 'algoliasearch';

const client = algoliasearch(environment.algolia.appId, environment.algolia.adminAPIKey);
const index = client.initIndex('projects');
const index2 = client.initIndex('contacts');

@Component({
  selector: 'app-edit-project-dialog',
  templateUrl: './edit-project-dialog.component.html',
  styleUrls: ['./edit-project-dialog.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  }
})
export class EditProjectDialogComponent implements OnInit {
  editProjectForm:FormGroup;
  clients:any[]=[];
  locations:any[]=[];
  projectData:any;
  submitted:Boolean=false;
  successMsg:any;
  errMsg:any;
  searchContacts:any[];
  selectedContactId:string;
  addressGoogleObject  ={};
  showrooms:any;
  designerList:any;
  contactSourceList:any;
  contactData:any;
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  private subscription4: Subscription;
  statusList = [
    {'status_id':'none', 'status_name':"-None-"  },
    {'status_id':'29', 'status_name':"Prospect / Lead"  },
    {'status_id':'design_consultation', 'status_name':"Design Consultation"  },
    {'status_id':'design_presentation', 'status_name':"Design Presentation"  },
    {'status_id':'retained', 'status_name':"Retained"  },
    {'status_id':'ordered', 'status_name':"Ordered"  },
    {'status_id':'lost', 'status_name':"Lost"  },
    {'status_id':'cancelled', 'status_name':"Cancelled"  },
    {'status_id':'delayed', 'status_name':"Delayed"  },
    {'status_id':'delivered', 'status_name':"Delivered"  },
    {'status_id':'finished', 'status_name':"Finished"  },
    {'status_id':'installation', 'status_name':"Installation"  },
    {'status_id':'received', 'status_name':"Received"  },
    {'status_id':'sold', 'status_name':"Sold"  },
  ];
  constructor(
    public dialogRef: MatDialogRef<EditProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin:AdminService,
    private _project : ProjectService,
    private _lead : LeadService,
    private _toastr: ToastrService
  ) { }

  ngOnInit() {
    this.editProjectForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      first_name: [null, [Validators.required]],
      last_name: [null, []],
      accounting_ref: ["", []],
      budget: ["", []],
      status_id: ["", []],
      contact_id: ["", []],
      address : [null, []],
      mobile_phone : [null, []],
      email : [null, []],
      contact_source_id : [null, []],
      owner_contact_id : [null, []],
      showroom : [null, []],
    })
    // if(emailList.includes(localStorage.getItem('rs-email'))){
    //   this.getClientList('all');
    // }else {
    //   this.getClientList('filter');
    // }
    
    this.getProjectDetail(this.data.id);
    this.getShowroomList();
    this.getcontactSourceList();

    if(emailListCreateContact.includes(localStorage.getItem('rs-email'))){
      this.getDesignerList('all');
    }
    else {
      this.getDesignerList(localStorage.getItem('uid'));
    }
  }

  onClick(event) {
    const divSec = (<Element>event.target).className;
    if (!divSec.includes('location-area')) 
      this.locations = [];
   }

   getSuggestions(event){
    this._admin.getSuggestions(event.target.value).subscribe(res => {
      //  this.locations = res["data"].map(item=>item.description);
      this.locations = res["data"];
    },err=>{
      this._common.showLoader(false);
      this.errMsg = err.message
    })   
  }

  get fval() {
    return this.editProjectForm.controls;
  }

  getClientList(listType){
    this._common.showLoader(true);
    if(listType==="all"){
      this.subscription = this._lead.getAllContacts().subscribe(res=>{
        this.clients = res;
      },error=>{
        this.errMsg = error.error.message ? error.error.message :'Something went wrong!';
      })  
    }
    else {
      this.subscription2 = this._lead.getFilteredContacts(localStorage.getItem('uid')).subscribe(res=>{
        this.clients = res;
      },error=>{
        this.errMsg = error.error.message ? error.error.message :'Something went wrong!';
      })  
    }
    // this._common.showLoader(true);
    // this._project
    // .getClientList().subscribe(res =>{
    //   this._common.showLoader(false);
    //   this.clients = res;
    // },error=>{
    //   alert('Something went wrong!');
    // });
  }
  setLocation(location){
    this.editProjectForm.patchValue({address:location.description});
    this.addressGoogleObject = location;
    this.locations =[];
  }

  getProjectDetail(id){
    this._common.showLoader(true);
    this.subscription3 = this._admin.getProjectDetail(id).subscribe(resp=>{
      this._common.showLoader(false);
      this.projectData = resp;
      if(this.projectData.payload.data().contact_id){
        this.selectedContactId = this.projectData.payload.data().contact_id;
        this.subscription4 = this._lead.getContactById(this.projectData.payload.data().contact_id).subscribe(contactRes=>{
          if(contactRes && contactRes.payload.data()){
            this.contactData = contactRes.payload.data();
            this.editProjectForm.patchValue({
              contact_id: this.contactData['first_name'] +' '+ this.contactData['last_name'],
              name : this.projectData.payload.data().name ? this.projectData.payload.data().name :'',
              first_name: this.contactData['first_name'],
              last_name: this.contactData['last_name'],
              accounting_ref : this.projectData.payload.data().accounting_ref,
              status_id : this.projectData.payload.data().status_id ? this.projectData.payload.data().status_id : '',
              budget : this.projectData.payload.data().budget,
              address : this.projectData.payload.data().address,
              mobile_phone : this.contactData['mobile_phone'],
              email : this.contactData['email'],
              contact_source_id : this.contactData['contact_source_id'],
              owner_contact_id : this.projectData.payload.data().owner_contact_id,
              showroom : this.contactData['showroom_default_id'],
            });
          }
        },err=>{
          this.errMsg = 'contact data not found';
        })
      }
      // this.editProjectForm.patchValue({
      //   name : this.projectData.payload.data().name ? this.projectData.payload.data().name :'',
      //   accounting_ref : this.projectData.payload.data().accounting_ref,
      //   status : this.projectData.payload.data().status_id ? this.projectData.payload.data().status_id : '',
      //   address : this.projectData.payload.data().address,
      // })

    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }

  // Get showroom list
  getShowroomList(){
    this._common.showLoader(true);
    this.subscription = this._admin.geShowroomList().subscribe(result=>{
      this._common.showLoader(false);
      this.showrooms = result;
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }

  // Get designer list
  getDesignerList(listType){
    this._common.showLoader(true);
    this.subscription2 = this._lead.getDesignerList(listType).subscribe(result=>{
      this._common.showLoader(false);
      this.designerList = result.map(item=> item.payload.doc.data());
    },error=>{
      this._common.showLoader(false);
      this._alert.error('Something went wrong');
    })
  }

  // get contact source list
    getcontactSourceList(){
      this._common.showLoader(true);
      this.subscription3 = this._admin.getContactSourceList().subscribe(result=>{
        this._common.showLoader(false);
        this.contactSourceList = result;
      },error=>{
        this._common.showLoader(false);
        this._alert.error('Something went wrong');
      })
    }
  


  hideEventDialog() {
    this.dialogRef.close();
  }

  setContact(item){
    this.selectedContactId = item.id;
    this.editProjectForm.patchValue({contact_id: `${item.first_name} ${item.last_name}` });
    this.searchContacts =[];
  }


  onFormSubmit(){
    this.submitted = true;
    if(!this.editProjectForm.value.name){
      alert('Project Name is required');
    }
    if(!this.editProjectForm.value.first_name){
      alert('Contact First Name is required');
    }
    if (this.editProjectForm.invalid) {
      return;
    } 
    let form = this.editProjectForm.value;
    
    this._common.showLoader(true);
    const statusObj = this.statusList.filter(item=> item.status_id == this.editProjectForm.value.status_id);
    let ind = this.designerList.findIndex(item => item.id=== this.editProjectForm.value.owner_contact_id);
    let data:any = {
      name : this.editProjectForm.value.name,
      accounting_ref : this.editProjectForm.value.accounting_ref,
      status_id : this.editProjectForm.value.status_id || '',
      status_name : statusObj.length>0 && statusObj[0].status_name ? statusObj[0].status_name : '',
      budget : this.editProjectForm.value.budget,
      contact_id : this.selectedContactId,
      address : this.editProjectForm.value.address,
      owner_contact_id : this.editProjectForm.value.owner_contact_id,
      owner_first_name : this.designerList[ind].first_name || '',
      owner_last_name : this.designerList[ind].last_name || '',
      owner_user_id : this.designerList[ind].user_id || '',
    }
    if(this.addressGoogleObject){
      data.address_google = JSON.stringify(this.addressGoogleObject);
    }

    if(data['date_updated']===undefined){
      data['date_updated'] = Date.now();
    }
    const contactObj = {
      first_name: this.editProjectForm.value.first_name,
      last_name: this.editProjectForm.value.last_name,
      mobile_phone : this.editProjectForm.value.mobile_phone,
      email : this.editProjectForm.value.email,
      contact_source_id : this.editProjectForm.value.contact_source_id || '',
      owner_contact_id : this.editProjectForm.value.owner_contact_id,
      showroom_default_id : this.editProjectForm.value.showroom || '',
    }
      // Update contacts
      this._lead.updateContact(contactObj,this.contactData.id).then(res => {
        this._admin.editProject(data,this.data.id).then(res => {
            // Update accounting ref into project map nodes
            if(this.editProjectForm.value.accounting_ref){
              
              this._admin.getAccoutingRef(this.data.id,'2xRks4oV4X2XHFTstXtO').then((res:any) => {
                  if(res.length>0){
                  this._admin.editProjectMapNode({"value":this.editProjectForm.value.accounting_ref},res[0].payload.doc.id).then(res => {
                    this._common.showLoader(false);
                    this.dialogRef.close();
                    this._toastr.success(`Project edited successfully!`,"",{ timeOut: 4000 });                

                  },err=>{
                    this._common.showLoader(false);
                    this._toastr.error(`Something went wrong!`,"",{ timeOut: 4000 });
                  }) 
                }
                else{
                  this._common.showLoader(false);
                  this.dialogRef.close();
                  this._toastr.success(`Project edited successfully!`,"",{ timeOut: 4000 });                
                }
              }).catch(err=>{
                this._common.showLoader(false);
                this._toastr.error(`Something went wrong!`,"",{ timeOut: 4000 });
              })
            }
            else {
              this._common.showLoader(false);
              this.dialogRef.close();
              this._toastr.success(`Project edited successfully!`,"",{ timeOut: 4000 });            
      
            }
         
        },err=>{
          this._common.showLoader(false);
          this._toastr.error(`Something went wrong!`,"",{ timeOut: 4000 });
        }) 
      },err=>{
        this.dialogRef.close();
        this._common.showLoader(false);
        this.errMsg = "Something went wrong"
        this._toastr.error(`${this.errMsg}`,"",{ timeOut: 4000 });
      })

 
  }

  // Search Algolia...
  searchAlgolia(form){
    this.searchContacts = [];
    const requestOptions = {
      headers: { }
    }
    
    // Search Contacts...      
    index2.search(form.value.contact_id, requestOptions)
    .then(({ hits }) => {
      if(form.value.keyword!=""){
        this.searchContacts = hits.map(item=>{ return { first_name: item['first_name'], last_name: item['last_name'], id: item.objectID}});
      }
    }); 
  }

  removeLocation(){
    // this.locations =[];
  }


  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
    if(this.subscription3) this.subscription3.unsubscribe();
    if(this.subscription4) this.subscription4.unsubscribe();
  }

}
